
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        loaded: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        empty: {
            type: Boolean,
            default: false,
        },
        noQuery: {
            type: Boolean,
            default: false,
        }
    }
})
